import React from 'react';
import { SEARCH_RENDERER_TYPE } from '../../rendererTypes';

export default {
  type: SEARCH_RENDERER_TYPE,
  render: () => <div slot="search" />,
  schema: {},
};
